import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { agentReportDetailsGet } from '../../../store/slices/tenantSlices/agentPerformanceSlice';
import CallexLoader from '../../../components/CallexLoader';
import { calculateDurations } from '../../../utils/common';

const DailyDetailedReportModal = ({ isOpen, onClose, data }) => {
  const dispatch = useDispatch();

  const [reportData, setReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getAgentReportDetails = async () => {
    setIsLoading(true);
    try {
      const processId = String(data?.process_id)
        ?.split(',')
        .map((item) => item.trim())
        .filter((item) => item !== '')
        .map(Number);

      const payload = {
        from_date: data?.from_date,
        to_date: data?.to_date,
        user_id: data?.user_id,
        archiveId: data?.archiveId,
        process_id: processId
      };
      const response = await dispatch(agentReportDetailsGet(payload)).unwrap();
      if (response && response.success) {
        setReportData(response.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getAgentReportDetails();
    }
  }, [isOpen]);

  const { durations, totalDuration } = calculateDurations(reportData || []);

  return (
    <div>
      <Modal isOpen={isOpen} size="lg">
        <ModalHeader className="text-center text-primary justify-content-center">
          DAILY DETAILED REPORT
        </ModalHeader>
        <ModalBody style={{ maxHeight: 'calc(100vh - 200px)' }}>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <CallexLoader />
            </div>
          ) : (
            <div
              className="daily-report-table"
              style={{ maxHeight: 'calc(100vh - 232px)' }}
              onClick={() => setReportData()}>
              <table className="report-list-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Process</th>
                    <th>Entry Time</th>
                    <th>End Time</th>
                    <th>Break</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData?.map((val, index) => {
                    const breakName = val?.break_name || '-';
                    return (
                      <tr key={index}>
                        <td>{data?.user}</td>
                        <td>{data?.Process}</td>
                        <td>{val?.break_name ? val?.break_in || '-' : val?.login || '-'}</td>
                        <td>{val?.break_name ? val?.break_out || '-' : val?.logout || '-'}</td>
                        <td>{breakName}</td>
                        <td>{durations[index].formattedDuration}</td>
                      </tr>
                    );
                  })}
                  <tr style={{ background: '#2cd07e33' }}>
                    <td colSpan="5">TOTAL</td>
                    <td>{totalDuration}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

DailyDetailedReportModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.obj
};

export default DailyDetailedReportModal;
